import React, { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
  CurrencyDollarIcon,
  InformationCircleIcon,
  XIcon,
} from '@heroicons/react/outline'
import Logo from 'app/components/Icons/Logo'

type Props = {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}
const RebuyModal = (props: Props) => {
  const { openModal, setOpenModal } = props

  return (
    <Transition.Root show={openModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpenModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Overlay className="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform rounded-lg shadow-xl bg-ebony-clay-500 sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="text-gray-400 rounded-md bg-ebony-clay-500 hover:text-gray-500"
                    onClick={() => setOpenModal(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XIcon className="w-6 h-6" aria-hidden="true" />
                  </button>
                </div>
                <div>
                  <div className="flex items-center justify-center w-12 h-12 mx-auto rounded-full">
                    <Logo />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-white"
                    ></Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-300 ">
                        Would you like to reinvest your BUSD staking rewards
                        back into XOPAD to compound your returns?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center mt-5 sm:mt-6">
                  <a
                    type="button"
                    href="https://xodex.app/#/swap?outputCurrency=0xBD40E2C830E1066D20E72a0cF2E55a19398752f6"
                    className="inline-flex items-center px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-spring-green-600 hover:bg-spring-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-spring-500"
                  >
                    <svg
                      width={19.8}
                      height={19.9}
                      className="mr-3 -ml-1 "
                      viewBox="0 0 198 199"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      {...props}
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M98.552 198.607c-29.49-.022-53.246-7.027-69.844-19.609C11.91 166.265 3 148.195 3 127.748c0-19.701 8.891-33.907 18.952-43.51 7.884-7.525 16.584-12.344 22.642-15.117-1.37-4.162-3.079-9.61-4.608-15.238-2.046-7.53-4.053-16.366-4.053-22.84 0-7.663 1.687-15.36 6.238-21.34C46.98 3.385 54.218 0 62.926 0c6.806 0 12.584 2.499 17.108 6.81 4.324 4.12 7.202 9.593 9.189 15.298 3.491 10.024 4.85 22.618 5.232 35.187h8.341c.382-12.569 1.741-25.163 5.233-35.187 1.987-5.705 4.865-11.177 9.189-15.298C121.741 2.5 127.519 0 134.325 0c8.708 0 15.947 3.385 20.755 9.703 4.551 5.98 6.239 13.677 6.239 21.34 0 6.474-2.007 15.31-4.054 22.84-1.529 5.628-3.238 11.076-4.608 15.238 6.058 2.773 14.759 7.592 22.643 15.118 10.06 9.602 18.952 23.808 18.952 43.509 0 20.447-8.911 38.517-25.708 51.25-16.599 12.582-40.354 19.587-69.844 19.609h-.148Z"
                        fill="#633001"
                      />
                      <path
                        d="M62.926 7.288c-12.754 0-18.626 9.516-18.626 22.675 0 10.46 6.822 31.408 9.621 39.563.63 1.835-.36 3.844-2.164 4.555-10.222 4.031-40.39 18.789-40.39 52.588 0 35.603 30.658 62.448 87.191 62.491l.068-.001.067.001c56.534-.043 87.19-26.888 87.19-62.491 0-33.799-30.167-48.557-40.389-52.588-1.804-.71-2.794-2.72-2.164-4.555 2.799-8.154 9.621-29.103 9.621-39.563 0-13.16-5.871-22.675-18.626-22.675-18.36 0-22.936 26.007-23.263 53.92-.022 1.863-1.528 3.375-3.392 3.375H89.58c-1.863 0-3.37-1.512-3.391-3.375-.326-27.913-4.903-53.92-23.263-53.92Z"
                        fill="#D1884F"
                      />
                      <path
                        d="M98.693 177.755c-41.538 0-87.253-22.235-87.325-51.018v.134c0 35.632 30.705 62.491 87.325 62.491 56.62 0 87.325-26.859 87.325-62.491v-.134c-.072 28.783-45.787 51.018-87.325 51.018Z"
                        fill="#FEDC90"
                      />
                      <path
                        d="M75.614 117.896c0 9.718-4.593 14.779-10.258 14.779-5.665 0-10.258-5.061-10.258-14.779s4.593-14.779 10.258-14.779c5.665 0 10.258 5.061 10.258 14.779ZM142.288 117.896c0 9.718-4.592 14.779-10.257 14.779-5.666 0-10.258-5.061-10.258-14.779s4.592-14.779 10.258-14.779c5.665 0 10.257 5.061 10.257 14.779Z"
                        fill="#633001"
                      />
                    </svg>
                    Buy on PancakeSwap
                  </a>
                </div>
                <div className="flex p-4 mt-5 rounded-lg">
                  <svg
                    className="flex-shrink-0 w-5 h-5 dark:text-gray-300"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <div className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                    Return to this page and stake your new tokens to increase
                    your{' '}
                    <a
                      href="https://www.youtube.com/watch?v=lNK95khKvSk"
                      target="_blank"
                      className="font-semibold underline hover:text-gray-800 dark:hover:text-white"
                    >
                      compounding
                    </a>{' '}
                    rate of return.
                  </div>
                </div>
              </Dialog.Overlay>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default RebuyModal
